module.exports = __webpack_public_path__ + "static/media/greyStar.59ead876.svg";